import { z } from "zod";

const ProjectEvaluationToastTypeValues = ["MESSAGE", "SCHEDULED_MESSAGE"] as const;

const ProjectEvaluationToastTypeSchema = z.enum(ProjectEvaluationToastTypeValues);
export const ProjectEvaluationToastType = ProjectEvaluationToastTypeSchema.enum;
export type ProjectEvaluationToastType = (typeof ProjectEvaluationToastTypeValues)[number];
